import type { ScrollTweenFunction } from '../types';
import { gsap } from 'gsap';

/**
 * Scroll Animation Logic
 */
export const scroll: ScrollTweenFunction = ({
    target, scrollTimeline, direction, top, pageIndex, numberOfPages, duration, insertTweenAt, containersToTap
}) => {
    if (!scrollTimeline || typeof pageIndex === 'undefined' || typeof numberOfPages === 'undefined' || typeof duration === 'undefined' || typeof insertTweenAt === 'undefined') return;

    // work out distance required to move the element fully outside the viewport
    const el =
        typeof target === "string"
            ? (document.querySelector(target) as HTMLElement | null)
            : (target as HTMLElement | null);
    if (!el) return;
    const offscreenOffset = el.scrollHeight + (window.innerHeight / 2); // px value
    //console.log(el.scrollHeight, window.innerHeight)
    if (direction === "forward" || direction === "init") {
        if (top) {
            if (pageIndex < numberOfPages) {
                gsap.set(target, { y: 0, autoAlpha: 1 });
                const tween = gsap.to(target, { y: `-${offscreenOffset}px`, ease: "none", duration });
                scrollTimeline.add(tween, direction === "init" ? 0 : insertTweenAt);
            }
        } else {
            gsap.set(target, { y: `${offscreenOffset}px`, autoAlpha: 1 });
            const tween = gsap.to(target, { y: 0, ease: "none", duration });
            scrollTimeline.add(tween, "<");
        }
    }

    if (direction === "back") {
        const backDuration = containersToTap ? 50 : 100;
        const backInsertTweenAt = containersToTap ? 50 : 0;
        if (top) {
            gsap.set(target, { autoAlpha: 1 });
            const tween = gsap.to(target, { y: `-${offscreenOffset}px`, ease: "power2.inOut", duration: backDuration });
            scrollTimeline.add(tween, backInsertTweenAt);
        } else {
            gsap.set(target, { y: `${offscreenOffset}px`, autoAlpha: 1 });
            const tween = gsap.to(target, { y: 0, ease: "power2.inOut", duration: backDuration });
            scrollTimeline.add(tween, "<");
        }
    }
};
